/**
 * Created by Ning Jiang on 2/28/2018.
 */

import {ISymbolStateConfig, SymbolStateTransition} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Timeline, TimelineLite, TweenLite} from "gsap";
import {BasicStateReelSymbol} from "../symbols/BasicStateReelSymbol";
import {TractorBeamGameConfig} from "../TractorBeamGameConfig";

export class TractorBeamScatterReelSymbol extends BasicStateReelSymbol {

    private _attentionOverlayContainer:PIXI.Container;
    private _isAttentionPlaying:boolean = false;
    private _removeAttentionTimeline:TimelineLite;
    private _stopped:boolean = false;
    private _freespinOverlayContainer:PIXI.Container;

    // Overlay scatter animations
    private _spinByEffect:TimelineSprite | null;
    private _idleEffect:TimelineSprite | null;

    constructor(symName:string, reelId:number, state?:ISymbolStateConfig) {
        super(symName, reelId, state);
    }

    protected initState(stateConfig:ISymbolStateConfig):boolean {
        if(super.initState(stateConfig)) {
            // To move the patches always on the top.
            if(this._attentionOverlayContainer) {
                this.addChild(this._attentionOverlayContainer);
            }

            if(this._freespinOverlayContainer) {
                this.addChild(this._freespinOverlayContainer);
            }

            if(!this._spinByEffect) {
                const attentionEffect:TimelineSprite = new TimelineSprite(GameResources.getTextures("S_glowBall"));
                attentionEffect.blendMode = PIXI.BLEND_MODES.SCREEN;
                attentionEffect.anchor.set(0.5, 0.75);
                this._spinByEffect = attentionEffect;
                this._spinByEffect.alpha = 0;
                //this.addChild(this._spinByEffect);
            }

            if(!this._idleEffect) {
                const idleEffect:TimelineSprite = new TimelineSprite(GameResources.getTextures("S_idle"));
                idleEffect.blendMode = PIXI.BLEND_MODES.SCREEN;
                idleEffect.anchor.set(0.5, 0.5);
                idleEffect.hide();
                this._idleEffect = idleEffect;
                //this.addChild(this._idleEffect);
            }

            return true;
        }

        return false;
    }

    /*public hideSpineLayer():void {
        if(this._idleEffect) {
            this._idleEffect.hide();
        }
    }*/

    protected addNewStateAnimation(timeline:TimelineLite, newState:SymbolStateTransition, stateAnimation:TimelineSprite, delay:number):void {
        super.addNewStateAnimation(timeline, newState, stateAnimation, delay);

        if(newState.state.keyword === TractorBeamGameConfig.instance.SYMBOL_STATES.attention.keyword) {
            timeline.add(this.playScatterAttentionOverlay(), delay);
        }

        if(newState.state.keyword === TractorBeamGameConfig.instance.SYMBOL_STATES.spin.keyword) {
            /*timeline.add([
                () => {
                if(this._spinByEffect && this.children[0]) {
                    this.children[0].visible = false;
                    this._spinByEffect.alpha = 1;
                }
                },
                () => {
                    if(this._spinByEffect) {
                        this._spinByEffect.playLoop();
                    }
                }
            ]);*/
        }

        if(newState.state.keyword === TractorBeamGameConfig.instance.SYMBOL_STATES.normal.keyword) {
            //timeline.add(() => this.getScatterIdleAnimation(delay));
        }
    }

    protected addOldStateAnimation(timeline:TimelineLite, transition:SymbolStateTransition, stateAnimation:TimelineSprite, delay:number):void {
        super.addOldStateAnimation(timeline, transition, stateAnimation, delay);

        if(transition.state.keyword != TractorBeamGameConfig.instance.SYMBOL_STATES.attention.keyword && transition.state.keyword != TractorBeamGameConfig.instance.SYMBOL_STATES.win.keyword) {
            //timeline.add(() => this.removeScatterAttentionOverlay(), delay);
        }

        if(transition.state.keyword != TractorBeamGameConfig.instance.SYMBOL_STATES.spin.keyword) {
            //timeline.add(() => this.removeScatterAttentionOverlay(), delay);

            if(this._spinByEffect) {
                //timeline.add(() => this.getScatterGlowBallEndAnimation(delay));
            }
        }

        if(transition.state.keyword != TractorBeamGameConfig.instance.SYMBOL_STATES.normal.keyword && transition.state.keyword != TractorBeamGameConfig.instance.SYMBOL_STATES.attention.keyword) {

            /*if(this._idleEffect) {
                timeline.add(TweenLite.to(this._idleEffect, 0.4, {
                    alpha: 0
                }), delay);
                timeline.add([
                    () => {
                        if(this._idleEffect) {
                            this._idleEffect.hide();
                            this._idleEffect.stopLoop();
                            this._idleEffect = null;
                        }
                    }
                ]);
            }*/
        }
    }

    private getScatterGlowBallEndAnimation(delay:number):Timeline {
        const timeline:Timeline = new TimelineLite();


        if(this._spinByEffect) {
            timeline.add(TweenLite.to(this._spinByEffect, 0.4, {
                alpha : 0
            }), delay);
            timeline.add([
                () => {
                    if(this._spinByEffect) {
                        this._spinByEffect.stopLoop();
                        this._spinByEffect = null;
                    }
                }
            ]);
        }

        return timeline;
    }

    // TODO: Probably need to activate this externally, or move out entirely, currently can start playing before all reels have stopped
    private getScatterIdleAnimation(delay:number, interval:number = 5):Timeline {
        const timeline:Timeline = new TimelineLite();

        timeline.add([
            () => {
                if(this._idleEffect) {
                    this._idleEffect.show();
                    this._idleEffect.playLoop()
                }
            }
        ], delay);
        /*timeline.add(() => {
            // complete time
        }, interval);*/

        //this._idleTimeline = timeline;
        return timeline;
    }

    private playScatterAttentionOverlay():TimelineLite {

        const timeline:TimelineLite = this.createAttentionAnimation();

        this._stopped = false;
        this._isAttentionPlaying = true;
        return timeline;
    }

    private createAttentionAnimation():TimelineLite {
        const winTl:TimelineLite = new TimelineLite();
        /*winTl.add(new TweenLite(this.scale, 0.1, {x : 1.2, y : 1.2}));
        winTl.add(new TweenLite(this.scale, 0.1, {x : 1, y : 1, onComplete : () => {
                if(this._stopped) {
                    return;
                }
                //this.createAttentionAnimation();
            }}));*/
        return winTl;
    }

    private removeScatterAttentionOverlay():TimelineLite {
        if(!this._isAttentionPlaying) {
            return new TimelineLite();
        }
        this._stopped = true;
        this._isAttentionPlaying = false;
        this._removeAttentionTimeline = new TimelineLite();


        return this._removeAttentionTimeline;
    }


    protected reset(remove:boolean):void {
        super.reset(remove);
        if(this._removeAttentionTimeline && this._removeAttentionTimeline.isActive()) {
            this._removeAttentionTimeline.pause();
            this._removeAttentionTimeline.kill();

        }

        this._isAttentionPlaying = false;

        if(!remove) {
            // Should remove all extra container, but we don't really need it here since there is no symbol replacing.
        }
    }
}
